import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowTriangleLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowTriangleLeft"><Path d="M20.0002 20.6179V3.38184L2.76416 11.9999L20.0002 20.6179Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowTriangleLeft;
